import { render, staticRenderFns } from "./ProcedimentoLista.vue?vue&type=template&id=0183b0ea&"
import script from "./ProcedimentoLista.vue?vue&type=script&lang=js&"
export * from "./ProcedimentoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports